import { CustomYup } from '@/utils'

export const validationSchema = (roleName = '') => {
  return CustomYup.object({
    role_ids: CustomYup.array().min(1, 'Perfil es requerido'),
    resource_id: CustomYup.string()
      .nullable()
      .when([], {
        is: () => roleName === 'contractor',
        then: () => CustomYup.string().required('Contratista es requerido')
      }),
    account_managment_id: CustomYup.number()
      .nullable()
      .when([], {
        is: () => roleName === 'Administrador de contrato',
        then: () =>
          CustomYup.number().required('Gerencia y subgerencia son requeridos')
      }),
    account_office_id: CustomYup.number()
      .nullable()
      .when([], {
        is: () => roleName === 'Control de acceso',
        then: () => CustomYup.number().required('Dependencia es requerido')
      }),

    has_local_document_number: CustomYup.boolean(),
    document_number: CustomYup.string()
      .nullable()
      .rut()
      .when('has_local_document_number', {
        is: false,
        then: () => CustomYup.string().nullable()
      })
  })
}
